export default "__VITE_ASSET__D$561Iro__"